import React, { Component } from "react";

import { bool, number, shape, func } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import Button from "pages/_components/Button";
import { string } from "yup";
import { connect } from "react-redux";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { isIOS, isMobile } from "react-device-detect";

class HistoricalBalanceItem extends Component {
    static propTypes = {
        account: shape({
            currency: number.isRequired,
        }).isRequired,
        date: string.isRequired,
        isDesktop: bool.isRequired,
        historicalBalance: shape({}).isRequired,
        dispatch: func.isRequired,
    };

    handleDownloadClick = () => {
        const { dispatch, account, date } = this.props;
        const { idProduct } = account;
        dispatch(accountsActions.downloadHistoricalBalances(idProduct, date, "pdf"));
    };

    render() {
        const { isDesktop, historicalBalance, account } = this.props;
        const { currency } = account;
        const { totalHistoricalBalance } = historicalBalance;
        const { date } = this.props;

        return date && !isIOS && !isMobile ? (
            <>
                <GridTable.Data columnStart={1} alignY="center">
                    <CustomText text={date} textType="DATE" keepSpaceIfNoText />
                </GridTable.Data>
                <GridTable.Data columnStart={2} alignX={isDesktop ? "center" : "right"} alignY="center">
                    <CustomText text={totalHistoricalBalance || "0"} textType={currency} keepSpaceIfNoText />
                </GridTable.Data>
                <GridTable.Data columnStart={3}  alignX={isDesktop && "right"} alignY="center">
                    <Button
                        image="images/download-primary.svg"
                        className="btn-only-icon btn-circle btn-inline"
                        label="download"
                        type="button"
                        onClick={this.handleDownloadClick}
                    />
                </GridTable.Data>
            </>
        ) : (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                    <GridTable.Data columnStart={1} alignY={isDesktop ? "left" : "middle"}>
                        <CustomText text="tableHeader.date" textType="I18N" />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1} alignY="center">
                        <CustomText className="font-weight-500" text={date} textType="DATE" keepSpaceIfNoText />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1} alignX="left">
                        <CustomText text="tableHeader.balance" textType="I18N" />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1} alignX="left" alignY="center">
                        <CustomText
                            className="font-weight-500"
                            text={totalHistoricalBalance || "0"}
                            textType={currency}
                            keepSpaceIfNoText
                        />
                    </GridTable.Data>
                </div>
                <div>
                    <Button
                        image="images/download-primary.svg"
                        className="btn-only-icon btn-circle"
                        label="download"
                        type="button"
                        onClick={this.handleDownloadClick}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    date: accountsSelectors.getDate(state),
});

export default connect(mapStateToProps)(HistoricalBalanceItem);
